import {$PropertyType} from 'utility-types'

import {MetaType} from 'types/Meta'

export const TRACK_PAGE_VIEW = 'TRACK_PAGEVIEW'
export type ActionType = {
  meta: MetaType
  pageName: string
  type: typeof TRACK_PAGE_VIEW
}

export const trackPageView = (
  pageName: $PropertyType<ActionType, 'pageName'>,
  meta: $PropertyType<ActionType, 'meta'>
): ActionType => ({
  meta,
  pageName,
  type: TRACK_PAGE_VIEW
})
